import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
const program = {
  state: () => ({
    items: [],
    filter: {
      searchTerm: null,
      skip: 0,
      take: 1000,
      total: 0,
      page: 1,
      saloonID: null,
      speakerID: null,
      dayID: null,
      subEventID: null,
    },
    selectedItems: [],
    loading: true,
    speakers: [],
  }),
  mutations: {
    setPrograms(state, payload) {
      state.items = payload.items;
      state.filter.total = payload.total;
      state.speakers = payload.speakers;
    },
    setSelectedPrograms(state, payload) {
      state.selectedItems = payload;
    },
    setProgramPage(state, payload) {
      state.filter.page = payload;
      this.dispatch("getPrograms");
    },
    setProgramTake(state, payload) {
      state.filter.page = 1;
      state.filter.take = payload;
      this.dispatch("getPrograms");
    },
    setProgramList(state, payload) {
      state.items = payload;
    },
  },
  actions: {
    async getPrograms(store) {
      store.state.items = [];
      store.state.loading = true;
      await axios
        .post("program/load", {
          ...store.state.filter,
          skip: (store.state.filter.page - 1) * store.state.filter.take,
        })
        .then((res) => {
          store.state.loading = false;
          return store.commit("setPrograms", res.data.data);
        });
    },
    async toggleProgram(store, payload) {
      var res = await axios.post("program/toggleisactive", {
        id: store.state.items[payload.index].id,
      });
      return res.data;
    },
    async deleteProgram(store, payload) {
      await axios
        .post("program/delete", {
          id: store.state.items[payload.index].id,
        })
        .then((res) => {
          if (res.data.alert.hasError) {
            payload.context.$message.error(res.data.alert.message);
          } else {
            store.state.items.splice(payload.index, 1);
            payload.context.$message.success(res.data.alert.message);
            if (store.state.items.length == 0 && store.state.filter.page != 1) {
              this.commit("setProgramPage", store.state.filter.page - 1);
            }
            store.state.filter.total = store.state.filter.total - 1;
          }
        });
    },
  },
  getters: {},
};
export default program;



// WEBPACK FOOTER //
// ./src/store/program.js